import { useEffect, useCallback } from 'react';
import capeService from '../services/capeService';

/**
 * Custom hook to handle CAPE content updates when user profile changes
 */
export const useCAPEProfileSync = (userId: string | undefined, profileUpdated: boolean = false) => {
  const syncCAPEWithProfile = useCallback(async () => {
    if (!userId) return;

    try {
      console.log('🔄 Syncing CAPE content with user profile...');
      
      // Update user's CAPE content based on new profile data
      const result = await capeService.updateUserCAPEContent(userId);
      
      if (result.success) {
        console.log('✅ CAPE content updated successfully:', result.message);
      } else {
        console.warn('⚠️ CAPE content update failed:', result.message);
      }
    } catch (error) {
      console.error('❌ Error syncing CAPE with profile:', error);
    }
  }, [userId]);

  // Sync when profile is updated
  useEffect(() => {
    if (profileUpdated && userId) {
      syncCAPEWithProfile();
    }
  }, [profileUpdated, userId, syncCAPEWithProfile]);

  return {
    syncCAPEWithProfile
  };
};

export default useCAPEProfileSync;
